import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import initActionsCreator from './redux/folderDeviationsInit';

export const getFolderDeviationsWidgetConfig = ({
  t,
  dispatch,
}): WidgetConfig => ({
  initActionsCreator,
});
